// Shared helpers for the live-poll controllers (dashboard column + subscriber card).

// Whole-percent share of total, floored at 0 (and 0 when there are no votes yet).
export function percent(count, total) {
  const t = Number(total) || 0;
  return t > 0 ? Math.round(((Number(count) || 0) * 100) / t) : 0;
}

// Parse an ISO closes_at into { remaining (seconds, floored at 0), label ("M:SS") }.
// Returns null for a missing or unparseable timestamp.
export function countdown(closesAt) {
  if (!closesAt) return null;

  const ts = Date.parse(closesAt);
  if (Number.isNaN(ts)) return null;

  const remaining = Math.max(0, Math.floor((ts - Date.now()) / 1000));
  const label = `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, "0")}`;
  return { remaining, label };
}
